function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetCollectionInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M40 12H22l-4-4H8c-2.2 0-4 1.8-4 4v8h40v-4c0-2.2-1.8-4-4-4Z",
    style: {
      fill: "#cecece",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 12H8c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V16c0-2.2-1.8-4-4-4Z",
    style: {
      fill: "#eaeae9",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1.47588,
      fill: "#d35dad",
      fillOpacity: 1
    },
    fill: "#4e7ab5",
    d: "M24.014 14.755a2.53 2.53 0 1 0 0 5.06 2.53 2.53 0 1 0 0-5.06zm0 20.24a1.687 1.687 0 1 0 0 3.374 1.687 1.687 0 1 0 0-3.374zm9.698-8.854a.843.843 0 1 0 0 1.686.843.843 0 1 0 0-1.686zm-19.398-1.266a2.109 2.109 0 1 0 0 4.218 2.109 2.109 0 1 0 0-4.218zm17.08-5.06a.633.633 0 1 0 0 1.266.633.633 0 1 0 0-1.267zm-14.128 12.44a1.898 1.898 0 1 0 0 3.795 1.898 1.898 0 1 0 0-3.796zm13.494.633a1.265 1.265 0 1 0 0 2.53 1.265 1.265 0 1 0 0-2.53zM17.16 17.91a2.304 2.304 0 1 0 0 4.608 2.304 2.304 0 1 0 0-4.608z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetCollectionInProgress);
export default __webpack_public_path__ + "static/media/datasetCollectionInProgress.4dfc195f4b296d5be9050f7cdbebe568.svg";
export { ForwardRef as ReactComponent };